module.exports = __webpack_public_path__ + "media/application/images/world-map-b07ae3ea0455fe7054231f963f535557.png";